import React from 'react'
import cx from 'classnames'
import { track } from 'analytics'

import { useUser } from 'modules/user'
import { ActionButton } from 'components/inputs'
import { Text } from 'components/dataDisplay'

import Banner from '../Banner/Banner'

import useNav from './util/useNav'


type NavProps = {
  className?: string
}

export const Nav: React.FunctionComponent<NavProps> = (props) => {
  const { gender } = useUser()
  const { className } = props

  const navItems = useNav()

  return (
    <div className={cx(className, 'flex w-full items-start self-center')} data-testid="nav">
      <div className={'w-6/12 pr-8'}>
        <Banner />
      </div>
      <ul className="w-6/12 self-center pl-72">
        {
          navItems.map((item, index) => {
            const { title, actionText, to, trackingKey } = { ...item, ...item[gender] }

            const trackLinkClick = () => {
              track('Search explore link click', {
                content: trackingKey,
                link: to,
              })
            }

            return (
              <li key={to} className={cx('mr-16 w-full', { 'mt-48': index })}>
                <Text style="p1" message={title} />
                <ActionButton className="mt-8" title={actionText} to={to} onClick={trackLinkClick} />
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default Nav
